import React, { memo, useState } from 'react';
import { fontSizeOptions, RICH_TYPE } from '@components/richEditor/configs';
import { CaretDownOutlined, LineHeightOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
// import { findParentNode } from '@utils';

function FontSizeDropdown({ onSelect }) {
  const [open, setOpen] = useState(false);

  const menu = (
    <Menu
      onClick={({ key }) => {
        onSelect(key);
        setOpen(false);
      }}
    >
      {fontSizeOptions.map((i) => (
        <Menu.Item key={i.value}>{i.label}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      onVisibleChange={setOpen}
      trigger={['click']}
      // getPopupContainer={(e) => findParentNode(e, 'fix-ratio-div')}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <div
        key={RICH_TYPE.FONT_SIZE}
        className="tool-btn with-antd-icon"
        onMouseDown={(e) => {
          e.preventDefault();
        }}
      >
        <LineHeightOutlined />

        <CaretDownOutlined className={open ? 'reverse' : ''} />
      </div>
    </Dropdown>
  );
}

export default memo(FontSizeDropdown);
